"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotInterpretableException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when attempting to parse some data but it cannot be parsed
 *
 * For example:
 * - Attempting to parse invalid JSON
 * - Attempting to decode a malformed JWT
 */
class NotInterpretableException extends domain_exception_1.DomainException {
    constructor(message, data) {
        super(message, data);
    }
}
exports.NotInterpretableException = NotInterpretableException;
